// extracted by mini-css-extract-plugin
module.exports = {"notFoundPage":"notFoundPage_notFoundPage__2w9nE","notFound":"notFoundPage_notFound__3A-a_"};